import { useState, useMemo } from "react";

export default function useActivityFilters(activities = []) {
  const [selectedType, setSelectedType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedRatingStatus, setSelectedRatingStatus] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  // Extract distinct activity types from activities
  const activityTypes = useMemo(() => {
    const types = new Set();
    activities.forEach((a) => {
      if (a.type) types.add(a.type);
    });
    return Array.from(types).sort();
  }, [activities]);

  const resetFilters = () => {
    setSelectedType("");
    setSelectedStatus("");
    setSelectedRatingStatus("");
    setDateFrom("");
    setDateTo("");
  };

  return {
    activityTypes,
    selectedType,
    setSelectedType,
    selectedStatus,
    setSelectedStatus,
    selectedRatingStatus,
    setSelectedRatingStatus,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    resetFilters,
  };
}
